import ArrayPool from "../../../utils/array-pool";
import { G_actions } from "../../../utils/globals/actions";
import getAllLayersResult from "./get-all-layers-result";

const arrayPool = new ArrayPool();

/**
 * Compute the final css
 * @param {MainClassProps} main
 * @param {Boolean} isInitial
 */
const computeFinalWithInitial = (main, isInitial) => {
  const activeProperties = main.activeProperties;
  const mainInitials = main.initials;
  const style = main.style;

  arrayPool.release(main.css);
  main.css = arrayPool.acquire();

  for (const [parent, initials] of mainInitials) {
    if (!activeProperties.has(parent) && !isInitial) {
      continue;
    }

    /** Check if the current property is transform to include the "shift" transform */
    const transform = parent === "transform";

    /** Get the "shift" transforms */
    const shift = main.shift;

    /** Active property data */
    const actives = activeProperties.get(parent);

    /** Computed all layers with divider and priority */
    const result = getAllLayersResult(
      initials,
      actives,
      isInitial,
      main,
      parent
    );

    /** Array of computed property values or layers */
    const array = result[0];

    /** Divider used to join the array */
    const divider = result[1];

    /** Has `!important` */
    const priority = result[2];

    /** Join multiple properties or layers */
    const joined = array.join(divider);

    /** Final string with `shift` applied. Apply only to `transform` */
    const final = transform ? `${shift.join(" ")} ${joined}` : joined;

    /** If initial trigger, add a property to global initial map */
    if (isInitial) {
      const name = /** @type {keyof ActionNameObjectProps} */ (parent);

      /** Remove initial action after initialization to prevent from triggering later */
      if (G_actions.has(name)) {
        main.initials.delete(name);
      } else {
        main.cssInitials.set(parent, [style, final, priority]);
      }
    } else {
      if (final) {
        main.css.push([style, parent, final, priority]);
      }
    }
  }
};

export default computeFinalWithInitial;
